import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { SelectField } from "./form/select_field";
import { CustomTextButton } from "./buttons/custom_text_button";
import { CustomButton } from "./buttons/custom_button";
import { fillPlusIcon } from "utils/data";

export const ViewMapFormScetion = ({ handleSubmit }) => {
  const [formData, setFormData] = useState({
    electorate: "",
    demographic: "",
    scaling: "",
    medianAge: "",
    age: "",
    showBooths: false,
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleReset = () => {
    setFormData({
      electorate: "",
      demographic: "",
      scaling: "",
      medianAge: "",
      age: "",
      showBooths: false,
    });
  };
  return (
    <Form className="mb-5" onSubmit={handleSubmit} onReset={handleReset}>
      <Row className="g-4">
        <Col xs={12}>
          <SelectField
            label="Electorate"
            className="bg-light"
            name="electorate"
            options={[
              { label: "Select", value: "" },
              { label: "Wills", value: "Wills" },
              { label: "Trusts", value: "Trusts" },
            ]}
            onChange={handleChange}
          />
        </Col>
        <Col xs={12}>
          <h5 className="text-secondary fw-semibold">Data Set</h5>
        </Col>
        <Col xs={6}>
          <SelectField
            label="Demographic"
            placeholder="Select"
            name="demographic"
            className="bg-light"
            options={[
              { label: "Select", value: "" },
              { label: "Wills", value: "Wills" },
              { label: "Trusts", value: "Trusts" },
            ]}
            onChange={handleChange}
          />
        </Col>
        <Col xs={6}>
          <SelectField
            label="Scaling"
            placeholder="Select"
            className="bg-light"
            name="scaling"
            options={[
              { label: "Select", value: "" },
              { label: "11", value: "11" },
              { label: "13", value: "13" },
            ]}
            onChange={handleChange}
          />
        </Col>
        <Col xs={6}>
          <SelectField
            label="Median Age"
            placeholder="Select"
            className="bg-light"
            name="medianAge"
            options={[
              { label: "Select", value: "" },
              { label: "11", value: "11" },
              { label: "13", value: "13" },
            ]}
            onChange={handleChange}
          />
        </Col>
        <Col xs={6}>
          <SelectField
            label="Age"
            placeholder="Select"
            name="age"
            className="bg-light"
            options={[
              { label: "Select", value: "" },
              { label: "11", value: "11" },
              { label: "13", value: "13" },
            ]}
            onChange={handleChange}
          />
        </Col>

        <Col xs={12}>
          <div className="d-flex justify-content-between flex-wrap">
            <Form.Check
              inline
              type="checkbox"
              label="Show Booths"
              id="show-booths"
              name="show-booths"
              onChange={(e) =>
                setFormData({
                  ...formData,
                  showBooths: e.target.checked,
                })
              }
            />

            <CustomTextButton
              color="text-secondary"
              value="Show Advancev Filters"
            />
          </div>
        </Col>
        <Col xs={12}>
          <div className="d-flex align-items-start gap-2">
            <img
              src={fillPlusIcon}
              width={20}
              height={20}
              alt="Plus Icon"
              className="mt-1"
            />

            <p className="m-0">Add Condition</p>
          </div>
        </Col>
        <Col xs={12} className="mt-5">
          <Row className="align-items-center">
            <Col xs={7}>
              <CustomButton
                className="btn-primary-gradient"
                type="submit"
                value="Show Results"
              />
            </Col>
            <Col xs={5}>
              <CustomTextButton value="Reset Map" type="reset" />
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
